<template>
  <Confirm />
  <ClientPublishDialog />
  <ClientAcceptingDialog />
  <ClientModalMiniatureWrapper />
  <ToastProvider>
    <TooltipProvider>
      <slot />
    </TooltipProvider>
  </ToastProvider>
</template>

<script setup lang="ts">
import './variables.css';
import { Confirm } from '../confirm';
import { ToastProvider } from '../toast';
import { TooltipProvider } from '../tooltip';
import ClientModalMiniatureWrapper from 'src/pages/(app)/components/clients-list/client-modal-miniature-wrapper/client-modal-miniature-wrapper.vue';
import { ClientPublishDialog } from '../client-publish-dialog';
import { ClientAcceptingDialog } from 'src/shared/ui/client-accepting-dialog';
</script>
